import { getClassesPendingSummaryTotal } from '@/data/services/classesPendingSummaryTotal';

export const classesPendingSummaryTotalQueries = {
  all: ['classesPendingSummaryTotal'] as const,

  get: () => ({
    queryKey: [...classesPendingSummaryTotalQueries.all, 'get'] as const,
    queryFn: () => getClassesPendingSummaryTotal(),
  }),
};
